<template>
  <b-modal ref="sides-modal" id="sides-modal" size="lg" body-class="sides-modal-body" hide-footer static>
    <template slot="modal-header">
      <h4 class="modal-title">Decorlijst</h4>
      <button type="button" aria-label="Close" @click="hideModal" class="close">
        <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
      </button>
    </template>
    <template slot="default">

      <div class="search-order col-md-12 mb-2 input-group">
        <div class="input-group-prepend">
          <span class="custom-input-group-text">
            <font-awesome-icon class="font-awesome-icon" icon="search"/>
          </span>
        </div>
        <input class="form-control" v-model="search" type="search" placeholder="Zoek op code of omschrijving...">
      </div>

      <template v-if="search">
        <b-card no-body class="mb-1">
          <b-card-header vheader-tag="header" role="tab">
            Zoekresultaten
            <span class="when-opened float-right"><font-awesome-icon class="font-awesome-icon" icon="caret-down"/></span>
            <span class="when-closed float-right"><font-awesome-icon class="font-awesome-icon" icon="caret-right"/></span>
          </b-card-header>
          <b-card-body>
            <div class="row">
              <div v-for="side in searchedSides" :key="side.key" class="col-md-6 mb-1">
                <div class="card cursor-pointer" @click="selectSide(side)">
                  <div class="row no-gutters">
                    <div class="col-auto">
                      <img v-lazy="side.image" :alt="side.label" class="img-fluid image-side" >
                    </div>
                    <div class="col">
                      <div class="card-block px-2">
                        <div class="side-label">{{ side.label }}</div>
                        <div class="side-description">{{ side.description }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </template>
      <template v-else>
        <b-card v-for="category in categories" no-body class="mb-1">
          <b-card-header v-b-toggle="'accordion-' + category" header-tag="header" role="tab">
            {{ category }}
            <span class="when-opened float-right"><font-awesome-icon class="font-awesome-icon" icon="caret-down"/></span>
            <span class="when-closed float-right"><font-awesome-icon class="font-awesome-icon" icon="caret-right"/></span>
          </b-card-header>
          <b-collapse :id="'accordion-' + category" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <div class="row">
                <div v-for="side in filteredSides(category)" :key="side.key" class="col-md-6 mb-1">
                  <div class="card cursor-pointer" :class="{'selected' : selectedMaterial === side.code}" @click="selectSide(side)">
                    <div class="row no-gutters">
                      <div class="col-auto">
                        <img v-lazy="side.image" :alt="side.label" class="img-fluid image-side" >
                      </div>
                      <div class="col">
                        <div class="card-block px-2">
                          <div class="side-label">{{ side.label }}</div>
                          <div class="side-description">{{ side.description }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </template>

    </template>
  </b-modal>
</template>

<script>
  export default {
    props: ['side'],
    data() {
      return {
        search: null
      }
    },
    computed: {
      sides() {
        return this.$store.getters.sides
      },
      searchedSides() {
        let sides = this.sides

        if (this.search) {
          let search = this.search.toLowerCase()
          sides = sides.filter(element => element.label.toLowerCase().indexOf(search) !== -1 || element.description.toLowerCase().indexOf(search) !== -1)
        }

        return sides
      },
      categories() {
        return [...new Set(this.sides.map(s => s.group))]
      },
      selectedMaterial() {
        let materialSide = !this.$store.getters.materialSide(this.side) ? false : this.$store.getters.materialSide(this.side)
        return !materialSide ? false : materialSide.code
      }
    },
    watch: {
      search() {
        this.$forceUpdate()
      }
    },
    methods: {
      filteredSides(category) {
        return this.sides.filter((element) => {
          return element.group === category
        })
      },
      selectSide(side) {
        this.$refs['sides-modal'].hide()
        this.$emit('selectSide', side)
      },
      showModal() {
        this.$refs['sides-modal'].show()
      },
      hideModal() {
        this.$refs['sides-modal'].hide()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }

  .side-label {
    color: $light-grey
  }

  .side-description {
    font-weight: bold;

  }

  .image-side {
    max-width: 75px;
  }
</style>
